var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProceedArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8307 6.08495L11.8635 1.07791C11.6344 0.848813 11.2625 0.845492 11.0334 1.07459C10.8043 1.3037 10.801 1.67557 11.0301 1.90467L15.0045 5.91229H0.587695C0.262305 5.91229 0 6.17459 0 6.49998C0 6.82538 0.262305 7.08768 0.587695 7.08768H15.0045L11.0301 11.0953C10.801 11.3244 10.8043 11.6963 11.0334 11.9254C11.2625 12.1545 11.6344 12.1512 11.8635 11.9221L16.8307 6.91502C17.0564 6.68592 17.0564 6.31405 16.8307 6.08495Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProceedArrow);
export default __webpack_public_path__ + "static/media/proceed-arrow.b6978bbecaef85e8c1cbcac06491f844.svg";
export { ForwardRef as ReactComponent };